export default __webpack_public_path__ + "static/stars-group-af2b9bdf80d8039cb2eb6b05e7977adc.png";